import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SortPipe } from './sort/sort.pipe';
import { AbbrevUomPipe } from './abbrev-uom/abbrev-uom.pipe';
import { PickPipe } from './pick/pick-data-from.pipe';

@NgModule({
  imports: [CommonModule],
  declarations: [SortPipe, AbbrevUomPipe, PickPipe],
  exports: [SortPipe, AbbrevUomPipe, PickPipe],
})
export class SharedPipesModule {}
